/* @jsx h */
import { computed, defineComponent, ref, h } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

export const EmailModal = defineComponent<{
  onClose: () => void;
  onSend: (email: string) => void;
}>({
  props: ["onClose", "onSend"],
  setup(props) {
    const { t } = useLocalization();
    const email = ref("");
    const isLoading = ref(false);
    const isValidEmail = computed(() =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value),
    );

    const handleSend = async () => {
      if (!isValidEmail.value) return;
      isLoading.value = true;
      try {
        await props.onSend(email.value);
        props.onClose();
      } catch (e) {
        // Error handling would be done by parent
      } finally {
        isLoading.value = false;
      }
    };

    return () => (
      <LemmonModal
        title={t("customer.receipt.email_receipt")}
        onClose={props.onClose}
        renderButtons={() => (
          <div class="p-4 border-t flex justify-between gap-3">
            <button onClick={props.onClose} class="btn btn-outline flex-1">
              {t("customer.account.cancel")}
            </button>
            <button
              onClick={handleSend}
              disabled={!isValidEmail.value || isLoading.value}
              class="btn btn-primary flex-1"
            >
              {isLoading.value ? (
                <span class="loading loading-spinner loading-sm"></span>
              ) : (
                t("customer.receipt.send_receipt")
              )}
            </button>
          </div>
        )}
      >
        <div class="p-6">
          <div class="mb-4">
            <label class="block text-sm font-medium mb-2">
              {t("customer.account.email_address")}
            </label>
            <input
              type="email"
              value={email.value}
              onInput={(e) =>
                (email.value = (e.target as HTMLInputElement).value)
              }
              placeholder={t("customer.receipt.email_placeholder")}
              class={`input input-bordered w-full ${
                email.value && !isValidEmail.value ? "input-error" : ""
              }`}
              autofocus
            />
            {email.value && !isValidEmail.value && (
              <p class="text-error text-sm mt-1">
                {t("customer.receipt.invalid_email")}
              </p>
            )}
          </div>
          <p class="text-sm text-base-content/70">
            {t("customer.receipt.email_copy")}
          </p>
        </div>
      </LemmonModal>
    );
  },
});
